import React, { Component, Fragment } from "react";
import { InfoBoard, InfoBoardHelper } from "./InfoBoard";

/**
 * InfoBoard 6 Variabelt inköp
 */
class InfoBoard6 extends Component {
    initialValuesLoaded = false;

    constructor(props) {
        super(props);
        this.state = this.getPopulatedData();
        this.updateParent();
    }
    
    componentDidMount() {}
    
    render() {
        const { sortIndex, data } = this.props;

        InfoBoardHelper.sortIndex = sortIndex;

        let {
            name,
            weight,
            production_time,
            production_cost,
            purchase_price
        } = this.state;

        if (this.initialValuesLoaded) {

            ['name', 'weight', 'production_time', 'production_cost', 'purchase_price'].forEach(useName => {

                const theField =
                    data.parentIndex !== null
                        ? `rows[${
                        data.parentIndex
                        }][${sortIndex}][${useName}]`
                        : `rows[${sortIndex}][${useName}]`;

                if (jQuery('input[name="'+theField+'"]').length > 0) {
                    const fieldValue =  jQuery('input[name="'+theField+'"]').val();

                    if (fieldValue != '') {
                        eval(useName + " = '" + fieldValue + "'");
                    }
                }
            });
        }

        return <Fragment>
                    {InfoBoardHelper.renderHiddenInput({
                        name: 'name',
                        value: name
                    })}
                    {InfoBoardHelper.renderHiddenInput({
                        name: 'weight',
                        value: weight
                    })}
                    {InfoBoardHelper.renderHiddenInput({
                        name: 'production_time',
                        value: production_time
                    })}
                    {InfoBoardHelper.renderHiddenInput({
                        name: 'production_cost',
                        value: production_cost
                    })}
                    {InfoBoardHelper.renderHiddenInput({
                        name: 'purchase_price',
                        value: purchase_price
                    })}
                     {InfoBoardHelper.renderHiddenInput({
                        name: 'infoboardType',
                        value: 6
                    })}
                </Fragment>;
    }

    getPopulatedData() {
        const { data, extendedData } = this.props;

        if (extendedData.name && extendedData.name != '') {
            data.name = extendedData.name;
        }

        if (extendedData.weight && extendedData.weight != '' && !isNaN(extendedData.weight)) {
            data.weight = extendedData.weight;
        }

        if (extendedData.production_time && extendedData.production_time != '') {

            const timeParts = extendedData.production_time.split(':');
            if (timeParts.length == 3) {
                if (parseInt(timeParts[0]) >= 0 && parseInt(timeParts[1]) >= 0 && parseInt(timeParts[1]) <= 59 && parseInt(timeParts[2]) >= 0 && parseInt(timeParts[2]) <= 59) {
                    data.production_time = extendedData.production_time;
                }
            }
        }

        if (extendedData.production_cost && extendedData.production_cost != '' && !isNaN(extendedData.production_cost)) {
            data.production_cost = extendedData.production_cost;
        }

        if (extendedData.purchase_price && extendedData.purchase_price != '' && !isNaN(extendedData.purchase_price)) {
            data.purchase_price = extendedData.purchase_price;
        }

        return data;
    }

    updateParent = () => {

        let { onChange } = this.props;
        const { data } = this.props;
        const {
            id,
            name,
            weight,
            production_time,
            production_cost,
            purchase_price
        } = data;

        if ("function" !== typeof onChange) {
            console.error("Missing function onChange");
            return false;
        }

        if (!this.initialValuesLoaded) {
            onChange(id, 'name', name);
            onChange(id, 'weight', weight);
            onChange(id, 'production_time', production_time);
            onChange(id, 'production_cost', production_cost);
            onChange(id, 'purchase_price', purchase_price);
            this.initialValuesLoaded = true;
        }
    };
}

export default InfoBoard6;